// @flow

import React from 'react';
import styled from 'styled-components';
import { Field, ErrorMessage } from 'formik';
import { Auth } from 'utils/ExportCommon';
import PhoneCode from 'components/shared/PhoneCodeComponent';
import { EyePassword } from '../EyePassword';

const StyledValidatedInput = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

const StyledInput = styled(Field)`
  display: block;
  width: 100%;
  height: 35px;
  padding: 10px 15px;
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: white;
  line-height: 35px;
  font-size: 14px;
`;

const StyledErrorMessage = styled(ErrorMessage)`
  color: red;
  position: absolute;
  top: 35px;
  font-size: 14px;
`;

const Wsapp = styled.img.attrs({
  src: Auth.wsapp
})`
  float: right;
  position: absolute;
  top: 6px;
  right: 9px;
`;

const StyledPhoneErrorMessage = styled(StyledErrorMessage)`
  position: static;
  text-align: left;
  top: 0;
`;

export default function FormFields({
  errors,
  touched,
  handleCountryCodeClick,
  handleCountryCodePicked,
  pickingCountryCode,
  countryCode,
  isExternalTenant,
  showErrorText = true
}: any) {
  const [showPassword, setShowPassword] = React.useState(false);

  const validationErrorClass = (
    hasError: boolean,
    showError: boolean
  ): string => {
    return showError && hasError ? 'has-error' : '';
  };

  return (
    <div>
      <StyledValidatedInput>
        <StyledInput
          type="text"
          name="name"
          placeholder="Nombre(s)"
          className={validationErrorClass(
            errors.name && touched.name,
            showErrorText
          )}
        />
        {showErrorText && <StyledErrorMessage name="name" component="div" />}
      </StyledValidatedInput>
      <StyledValidatedInput>
        <StyledInput
          type="text"
          name="last_name"
          placeholder="Apellido(s)"
          className={validationErrorClass(
            errors.last_name && touched.last_name,
            showErrorText
          )}
        />
        {showErrorText && (
          <StyledErrorMessage name="last_name" component="div" />
        )}
      </StyledValidatedInput>
      <StyledValidatedInput>
        <PhoneCode
          handleCountryCodeClick={handleCountryCodeClick}
          handleCountryCodePicked={handleCountryCodePicked}
          pickingCountryCode={pickingCountryCode}
          countryCode={countryCode}
          errors={errors.lada_plus_number}
          touched={touched.lada_plus_number && showErrorText}
          name="lada_plus_number"
          placeHolder={isExternalTenant ? 'Número de whatsapp' : undefined}
        />
        <Wsapp />
        {showErrorText && (
          <StyledPhoneErrorMessage name="lada_plus_number" component="div" />
        )}
      </StyledValidatedInput>
      <StyledValidatedInput>
        <StyledInput
          type="text"
          name="email"
          placeholder="Correo electrónico"
          className={validationErrorClass(
            errors.email && touched.email,
            showErrorText
          )}
        />
        {showErrorText && <StyledErrorMessage name="email" component="div" />}
      </StyledValidatedInput>
      <StyledValidatedInput>
        <StyledInput
          type={showPassword ? 'text' : 'password'}
          name="password"
          placeholder="Crea una contraseña"
          className={validationErrorClass(
            errors.password && touched.password,
            showErrorText
          )}
        />
        {showErrorText && (
          <StyledErrorMessage name="password" component="div" />
        )}
        <EyePassword
          showPassword={showPassword}
          colorIcon={'#858585'}
          style={{
            position: 'absolute',
            right: '10',
            top: '10'
          }}
          onClick={() => setShowPassword(!showPassword)}
        />
      </StyledValidatedInput>
    </div>
  );
}
